import SectionHeader from '../../../../components/SectionHeader/SectionHeader';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import Section from '../Section';
import AvailableProducts from './AvailableProducts';
import GridComponent from '../GridComponent/GridComponent';
import { useCommoditiesStore } from '../../hooks/useCommoditiesStore';

const Products = () => {
  const { commodities } = useCommoditiesStore();

  return (
    <Section>
      <SectionHeader>
        <FormattedMessage id={'app.products.availableProducts'} />
      </SectionHeader>
      <GridComponent
        components={commodities.map((commodity, index) => (
          <AvailableProducts key={index} type={commodity.type} years={commodity.years} />
        ))}
      />
    </Section>
  );
};

export default Products;
